import React, { Component } from 'react';
import './NewComicBookForm.css';
import { v4 as uuidv4 } from 'uuid';

class NewComicBookForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '',
            issue: '',
            variant: '',
            extraCopy: false
            //order: 4
            //the order state is for a later feature - rearranging the order of the list.  Right now the array is being sorted by title, I want to get it to a point when you can manually drag and drop the order as the user wants
        }
        this.handleAdd = this.handleAdd.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }
    handleChange(evt) {
        const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
        this.setState({
            [evt.target.name]: value
            
        })
        
    }
    handleAdd(evt) {
        evt.preventDefault();
        this.props.addComic({ ...this.state, id: uuidv4(), copySecured: false });
        this.setState({
            title: '',
            issue: '',
            variant: '',
            extraCopy: false
            //order: this.state.order + 1
        })
        
        
    }

    handleReset() {
        window.localStorage.clear();
        window.location.reload();
    }

  
    render() {
        return (
                <form onSubmit={this.handleSubmit} className="NewComicForm">
                    <div className="input-group row">
                        <div className="d-custom col-12">
                            <label htmlFor="title">Series Title:</label>
                            <input type="text"
                                placeholder="Enter Series Title"
                                id="title"
                                name="title"
                                required
                                value={this.state.title}
                                onChange={this.handleChange} />
                        </div>
                    </div>
                    <div className="input-group row">
                        <div className="d-custom col-12">
                            <label htmlFor="issue">Issue #:</label>
                            <input type="text"
                                placeholder="Enter Issue #"
                                id="issue"
                                name="issue"
                                required
                                value={this.state.issue}
                                onChange={this.handleChange} />
                        </div>
                    </div>
                    <div className="input-group row">
                        <div className="d-custom col-12">
                            <label htmlFor="variant">Variant?</label>
                            <input type="text"
                                placeholder="Enter Artist Name"
                                id="variant"
                                name="variant"
                                value={this.state.variant}
                                onChange={this.handleChange} />
                        </div>
                    </div>
                    <div className="input-group row">
                    <div className="col-12 d-custom justify-content-between py-3">
                            <label htmlFor="extraCopy">Extra Copy?</label>
                            <input type="checkbox"
                                id="extraCopy"
                                name="extraCopy"
                                checked={this.state.extraCopy} //note that a checkbox needs the 'checked' field and not value
                                //value={this.state.extraCopy}
                                onChange={this.handleChange} />
                        </div>
                    </div>
                    <div className="button-container">
                        <button onClick={this.handleAdd} className="btn btn-primary form-btn mr-4">Add</button>
                    <button onClick={this.handleReset} className="btn btn-primary form-btn">Reset List</button>
                    </div>
                </form>
            )
    }
}

export default NewComicBookForm;